import React, { useState, useEffect } from "react";
import "./AddMoney.css";

const AddMoney = () => {
  const [amount, setAmount] = useState("");
  const [user, setUser] = useState(null);
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser) {
      setUser(storedUser);
      fetchTransactions(storedUser.id);
    }
  }, []);

  const fetchTransactions = async (id) => {
    try {
      const res = await fetch(
        `https://rcfinder.online/api/get_transactions.php?user_id=${id}`
      );
      const data = await res.json();

      if (data.status) {
        setTransactions(data.transactions);
      }
    } catch (err) {
      console.log("Transaction Fetch Failed", err);
    }
  };

  const handlePayment = () => {
    if (!amount || amount < 100) {
      alert("Minimum ₹100 enter karo");
      return;
    }

    if (!user) {
      alert("User not found! Please login first");
      return;
    }

    window.location.href = 
      `https://rcfinder.online/api/create_payment.php?amount=${amount}&user=${user.id}`;
  };

  return (
    <div>
      <div className="addmoney-container">
        <h2 className="addmoney-title">Add Money to Wallet</h2>

        <input
          type="number"
          placeholder="Enter Amount (₹)"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          className="addmoney-input"
        />

        <button onClick={handlePayment} className="addmoney-btn">
          Proceed To Pay
        </button>
      </div>

      {/* =========================
          TRANSACTION HISTORY
      ========================== */}
      <div className="txn-container">
        <h3 className="txn-title">Recent Transactions</h3>

        {transactions.length === 0 ? (
          <p className="no-txn">No transactions found</p>
        ) : (
          <table className="txn-table">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Amount</th>
                <th>UTR</th>
                <th>Date</th>
              </tr>
            </thead>

            <tbody>
              {transactions.map((t, i) => (
                <tr key={i}>
                  <td>{t.order_id}</td>
                  <td>₹{t.amount}</td>
                  <td>{t.utr || "-"}</td>
                  <td>{t.txn_time}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

    </div>
  );
};

export default AddMoney;
